'use client';

import { LabelProviderTable, labelProviderTableTag } from '@ni/nimble-components/dist/esm/label-provider/table';
import { wrap } from '../../utilities/react-wrapper';

export { labelProviderTableTag };
export { type LabelProviderTable };
export const NimbleLabelProviderTable = wrap(LabelProviderTable);
